import { Chip } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import { colorMap, Theme } from '@/utils/constants';
import { mapColorNameToContrastColorName, mapLinkToProps } from '@/utils/helpers';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import { Author } from '../shared/Author';
import { HeaderContentProps } from './HeaderContent.interface';
import useStyles from './HeaderContent.styles';

const HeaderContent = ({
  title,
  shortDescription,
  author,
  theme = Theme.light,
  tags = [],
  backgroundColor = colorMap.eggshell,
}: HeaderContentProps) => {
  const classes = useStyles({});
  const chipColor = useMemo(
    () => mapColorNameToContrastColorName({ colorName: backgroundColor }),
    [backgroundColor],
  );

  const isValidTags = useMemo(() => tags && Array.isArray(tags) && tags.length > 0, [tags]);
  const singleTag = useMemo(() => tags && tags[0], [tags]);
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  /* eslint-disable react/no-danger */
  return (
    <div className={rootClassName}>
      {isValidTags && tags.length > 1 ? (
        <div className={classes.chips}>
          {tags.map((item: any, id) => (
            <Chip
              theme={theme}
              clickable
              label={item.label}
              chipColor={chipColor}
              isCategory
              multiple={tags.length > 1}
              // eslint-disable-next-line react/no-array-index-key
              key={`chip_${id}`}
              {...mapLinkToProps(item)}
            />
          ))}
        </div>
      ) : (
        singleTag && (
          <MuiTypography
            variant="overline"
            {...mapLinkToProps(singleTag)}
            className={classes.category}
          >
            {singleTag.label}
          </MuiTypography>
        )
      )}
      {title && (
        <MuiTypography
          variant="h2"
          component="h1"
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {shortDescription && (
        <MuiTypography
          variant="h6"
          component="div"
          className={classes.shortDescription}
          dangerouslySetInnerHTML={{ __html: shortDescription }}
        />
      )}
      {author?.name && (
        <Author theme={theme} variant="info" author={author} className={classes.author} />
      )}
    </div>
  );
};

export default memo(HeaderContent);
